const autoBind = require('auto-bind');

class Card{
    constructor(options = {}){ 
        this.createCard(options);
        autoBind(this);
    }

    createCard(options = {}){
        this.token = options.token;
        this.type = options.type;
        this.mainTitle = options.mainTitle;
        this.textField = options.textField;
        this.subTitle = options.subTitle;
        this.image = options.image;
    }
}

class CardManager {
  constructor(options = {}) {
    this.cards = [];
    this.maxLen = 10;
    this.addCardAsync = this.addCardAsync.bind(this);
    this.deleteCardByTokenAsync = this.deleteCardByTokenAsync.bind(this);
    this.deleteAllCardsAsync = this.deleteAllCardsAsync.bind(this);
    autoBind(this);
  }

  initCards(cards){
    if (cards instanceof Array){
      if (cards.length > this.maxLen){
        return;
      }
      this.cards = cards;
    }
  }

  createCard(options = {}){
      let newCard = new Card(options);
      return newCard;
  }

  getCards(){
      return this.cards;
  }

  addCardAsync(card){
    var that = this;
    return new Promise((resolve, reject) => {

      if (!card || !card.token){ 
        return resolve();  
      }
      while (that.cards.length >= that.maxLen){
        that.cards.pop();
      }
      that.cards.unshift(card);
      return resolve();
    });
  } 
  
  /**
   * @obsolete
   */
  deleteCardByTokenAsync(token){
    var that = this;
    return new Promise((resolve, reject) => {
      let delTargetIdx = that.cards.findIndex((card) =>{
        return card.token === token;
      });
      that.cards.splice(delTargetIdx,1);
      return resolve();
    });
  }

  /**
   * @obsolete
   */
  deleteAllCardsAsync(){
    var that = this;
    return new Promise((resolve, reject) => {
      that.cards.splice(0, that.cards.length);
      return resolve();
    });
  }
}


export default CardManager
